import { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import {
  Controller,
  FormContext,
  useForm,
  useFormContext,
} from 'react-hook-form'
import { FormControlLabel, Grid, Switch, TextField } from '@material-ui/core'

import { BaseDialog, LoadingFeedback, UserTypeAndSearchInput } from 'components'

import { useSnackbar } from 'hooks'

import helpers from 'helpers'
import * as service from 'service'

import schema from './schema'

const ChangeResponsibleDialog = ({
  organizationId,
  open,
  setOpen = () => {},
  refresh = () => {},
}) => {
  const [selectExistentResponsible, setSelectExistentResponsible] =
    useState(false)
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()

  const { getValues } = useFormContext()

  const formMethods = useForm({
    validationSchema: schema(selectExistentResponsible),
    defaultValues: {
      responsibleDpoId: getValues('responsibleDpo'),
      responsibleName: getValues('responsibleName'),
      responsibleEmail: getValues('responsibleEmail'),
    },
  })

  const { handleSubmit, errors, control, reset } = formMethods

  const onSubmit = async (data) => {
    setLoading(true)

    try {
      await service.backoffice.organizations.changeDPO({
        organizationId,
        organization: { ...data },
      })

      snackbar.open({
        message: 'Responsável alterado com sucesso!',
        variant: 'success',
      })

      refresh()
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
        variant: 'error',
      })
    } finally {
      setOpen(false)
      setLoading(false)
    }
  }

  const dpo = getValues('dpo')
  const substitute = getValues('substitute')

  useEffect(() => {
    if (open) {
      reset({ dpo, substitute })
    }
    // eslint-disable-next-line
  }, [open, dpo, substitute])

  return (
    <>
      <LoadingFeedback open={loading} />
      <BaseDialog
        open={open}
        setOpen={setOpen}
        title="Alteração de responsável"
        closeButtonText="Cancelar"
        actionButtonText="Alterar"
        dialogSize="sm"
        formRef="change-responsible-form"
        noMargin
        actionButton={handleSubmit(onSubmit)}
      >
        <FormContext {...formMethods}>
          <Grid item xs={12}>
            <Controller
              as={
                <FormControlLabel
                  control={
                    <Switch
                      color="primary"
                      onChange={(e) => {
                        setSelectExistentResponsible(e.target.checked)
                      }}
                    />
                  }
                  label="Usuário existente"
                  labelPlacement="start"
                />
              }
              name="selectExistentResponsible"
              control={control}
            />
          </Grid>
          {selectExistentResponsible ? (
            <Grid item xs={12}>
              <UserTypeAndSearchInput
                label="Email do Responsável"
                fieldName="responsibleDpo"
                setUserId={setSelectExistentResponsible}
                searchField="email"
              />
            </Grid>
          ) : (
            <Grid container spacing={1} justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <Controller
                  as={
                    <TextField
                      fullWidth
                      error={!!errors.responsibleName}
                      helperText={errors?.responsibleName?.message}
                      label="Nome do responsável"
                    />
                  }
                  control={control}
                  name="responsibleName"
                  mode="onBlur"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Controller
                  as={
                    <TextField
                      fullWidth
                      error={!!errors.responsibleEmail}
                      helperText={errors?.responsibleEmail?.message}
                      label="E-mail do responsável"
                    />
                  }
                  control={control}
                  name="responsibleEmail"
                  mode="onBlur"
                />
              </Grid>
            </Grid>
          )}
        </FormContext>
      </BaseDialog>
    </>
  )
}

ChangeResponsibleDialog.propTypes = {
  organizationId: PropTypes.number.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func,
  setLoading: PropTypes.func,
}

export default ChangeResponsibleDialog
